import { Fragment, PropsWithChildren } from "react";
import { useRoleGuard, UseRoleGuardProps } from "../hooks/useRoleGuard";

type RoleGuardProps = PropsWithChildren & {
    roles: UseRoleGuardProps["roles"];
};

/**
 * Shows its children if the user has one of the given roles.
 *
 * @see useRoleGuard
 */
export const RoleGuard = ({ roles, children }: RoleGuardProps) => {
    const hasRoles = useRoleGuard({ roles });
    if (!hasRoles) {
        return null;
    }

    return <Fragment>{children}</Fragment>;
};
